import Link from 'next/link';
import { useRouter } from 'next/router';
import { CarouselPortfolio } from '@/components/Portfolio/CarouselPortfolio';
import { useUser } from '@/contexts/AuthContext';
import { ICompany, IPortfolioItem } from '@/types/api/companies';
import { canEditCompanyInstitutionalPage } from '@/utils/components/institutionalPage';
import { ROUTER_PAGES } from '@/utils/constants';
import { Box, Button, Card, Divider, Grid, Typography } from '@mui/material';

interface IPortfolioCardProps {
  valuesPortfolioCard: Array<IPortfolioItem>;
  setIsOpenEditPortfolio: (value: number) => void;
  company: ICompany;
}

export const PortfolioCard = ({
  valuesPortfolioCard,
  setIsOpenEditPortfolio,
  company,
}: IPortfolioCardProps) => {
  const { isAuthenticated, user } = useUser();
  const router = useRouter();
  const { company_slug } = router.query;

  return (
    <Box sx={{ my: 2 }}>
      <Grid container rowSpacing={4} columnSpacing={4}>
        {valuesPortfolioCard.map(valueCard => {
          return (
            <Grid item xs={12} md={6} key={valueCard.id}>
              <Card
                sx={{
                  filter: 'drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.1))',
                  p: 2,
                  borderRadius: '12px',
                }}
              >
                <Link
                  passHref
                  href={`${ROUTER_PAGES.site}/${company_slug}/portfolio/${valueCard.slug}/`}
                >
                  <a style={{ display: 'flex', justifyContent: 'center' }}>
                    <CarouselPortfolio
                      altTitle={valueCard.title}
                      imagesList={valueCard.photos}
                      isPinned={valueCard.pinned}
                    />
                  </a>
                </Link>
                <Divider sx={{ my: 2 }} />
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    height: '110px',
                  }}
                >
                  <Typography
                    component="h1"
                    variant="subtitle2"
                    sx={{
                      display: '-webkit-box',
                      WebkitLineClamp: '1',
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {valueCard.title}
                  </Typography>
                  <Typography
                    component="p"
                    noWrap={false}
                    variant="caption"
                    color="rgba(0, 0, 0, 0.5)"
                    sx={{
                      display: '-webkit-box',
                      WebkitLineClamp: '2',
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      minHeight: '40px',
                    }}
                  >
                    {valueCard.description}
                  </Typography>
                  {(!isAuthenticated ||
                    !canEditCompanyInstitutionalPage(company, user)) && (
                    <Link
                      passHref
                      href={`${ROUTER_PAGES.site}/${company_slug}/portfolio/${valueCard.slug}`}
                    >
                      <a
                        data-testid="portfolio-link"
                        style={{
                          alignSelf: 'flex-end',
                          marginTop: 2,
                          padding: '6px 8px',
                          color: '#00A8F3',
                          fontSize: '14px',
                        }}
                      >
                        Ver mais
                      </a>
                    </Link>
                  )}
                  {isAuthenticated &&
                    canEditCompanyInstitutionalPage(company, user) && (
                      <Button
                        onClick={() => setIsOpenEditPortfolio(valueCard.id)}
                        sx={{ mt: 2, alignSelf: 'center' }}
                      >
                        editar
                      </Button>
                    )}
                </Box>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export type { IPortfolioCardProps };
